module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "package-card",
    class: _vm.$vuetify.breakpoint.width > 650 ? '' : 'w-100'
  }, [_c('div', [_c('div', {
    staticClass: "title pb-1"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle pb-4"
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('div', {
    staticClass: "pb-5"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("$" + _vm._s(_vm.price))]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v("/month")])]), _vm._v(" "), _vm._l((_vm.optionList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "d-flex align-center gap-10 pb-2"
    }, [_vm._m(0, true), _vm._v(" "), _c('span', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.text))])])
  })], 2), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "package-card-btn",
    attrs: {
      "block": "",
      "text": ""
    }
  }, [_vm._v(" Select ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "package-card__img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/check-icon-black.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebec4ffe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/components/package_card.vue
// module id = 1862
// module chunks = 180